import { useCallback, useEffect, useState } from "react";
import { DnaTestTracker } from "../../../utils/api-objects/DnaTestTracker";
import { getDnaTrackersByStatus } from "../../../utils/apis/tracker-service";
import { useAuth } from "../../../utils/context/AuthContext";
import { TrackingStatus } from "../../../utils/Enums";

export const useGetDnaTrackersByStatus = (status: TrackingStatus) => {
    const { auth } = useAuth();
    const idToken = auth.idToken;
    const [isLoading, setIsLoading] = useState(true);
    const [trackers, setTrackers] = useState<DnaTestTracker[]>([]);
    const [error, setError] = useState<string | null>(null);

    const fetchTrackers = useCallback(() => {
        if (!idToken) return;
        setIsLoading(true);
        setError(null);
        getDnaTrackersByStatus(
            status,
            idToken,
            (trackers) => {
                setTrackers(trackers);
                setIsLoading(false);
            },
            (error) => {
                setError(error);
                setIsLoading(false);
            }
        );
    }, [status, idToken]);

    useEffect(() => {
        fetchTrackers();
    }, [fetchTrackers]);

    return { trackers, isLoading, error, refetch: fetchTrackers };
}; 